import { useCallback, useState } from "react";
import { LendersRepository } from "@/api/lenders/repository";
import { LendersService } from "@/api/lenders/service";
import { ContractingCompaniesRepository } from "@/api/contracting-companies/repository";
import { ContractingCompaniesService } from "@/api/contracting-companies/service";
import type { ILender } from "@/types/companies-lenders";
import type { IContractingCompany } from "@/types/companies-contractors";
import { serverErrorHandler } from "@/utils/serverErrorHandler";

type IProps = {
  defaultLoading?: boolean;
};

type IGetCompanyDetailsArgs = {
  companyType: "lender" | "contractor";
  id: number | string;
};

type IReturnType = {
  getCompanyDetails: (p: IGetCompanyDetailsArgs) => Promise<void>;
  data: ILender | IContractingCompany | undefined;
  loading: boolean;
};

export const useCompanyDetails = (props?: IProps): IReturnType => {
  const [data, setData] = useState<ILender | IContractingCompany | undefined>(
    undefined,
  );
  const [loading, setLoading] = useState<boolean>(
    props?.defaultLoading || false,
  );

  const getCompanyDetails = useCallback(
    ({ id, companyType }: IGetCompanyDetailsArgs) => {
      setLoading(true);
      if (companyType === "lender") {
        const repository = new LendersRepository(new LendersService());
        return repository
          .getCompanyDetails({ id })
          .then((data) => {
            setData(data);
          })
          .catch(serverErrorHandler())
          .finally(() => setLoading(false));
      }
      const repository = new ContractingCompaniesRepository(
        new ContractingCompaniesService(),
      );
      return repository
        .getCompanyDetails({ id })
        .then((data) => {
          setData(data);
        })
        .catch(serverErrorHandler())
        .finally(() => setLoading(false));
    },
    [],
  );

  return { getCompanyDetails, loading, data };
};
